import { Component, OnInit ,Input} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { UserService } from 'src/app/services/user.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-export-activity-log',
  templateUrl: './export-activity-log.component.html',
  styleUrls: ['./export-activity-log.component.scss']
})
export class ExportActivityLogComponent implements OnInit {
  @Input() public Content: any;
  MonoWindowPDF: UntypedFormGroup
  public content: any;
  log_data: any[] = [];
  details_data: any;
  category: string;
  src: string;
  orgCode: string;
  Submodule:boolean=false;
  now = new Date();
  Datestring: string;
Orgtimezone : string;
  constructor(public modalRef: NgbActiveModal, private userService: UserService, public datepipe: DatePipe,
    private commonService: UserService) {
    this.src = "../../../assets/images/logo1.png";
    this.orgCode = this.commonService.getOrgCode();

  }

  ngOnInit(): void {
    this.log_data = [];
    this.details_data = [];
    this.category = "";
    this.Datestring = this.datepipe.transform(this.now.toUTCString(), 'dd-MMM-YYYY HH:mm:ss');
    this.Orgtimezone = this.userService.getLoggedUserOrgTimeZone();
    if (this.Content.content.log_data != null && this.Content.content.log_data.length > 1) {
      this.log_data = this.content.log_data;
    }
    else {
      this.log_data.push(this.Content.content.log_data);
    }
    this.details_data = this.Content.content.details_data;
   // this.category = this.Content.content.cat_type;
    if(this.Content.content.ModuleId=="grants")
    this.Submodule=true;
  else
  this.Submodule=false;
    this.userService.getLogo(this.orgCode).subscribe(result => {
      if (result === null || result === undefined || result === '') {
        this.src = "../../../assets/images/logo1.png";
      }
      else {
        if (result.FileExt == 'svg') {
          this.src = 'data:image/svg+xml;base64,' + result.Image;
        }
        else {
          this.src = 'data:image/png;base64,' + result.Image;
        }
      }
    });
  }

  closePopup() {
    this.modalRef.dismiss();
  }
}

